<template>
  <div class="drawer">
    <el-drawer
      size="534px"
      title="退款"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <!-- <img src="../../../../assets/img/remark.png" class="avatar"/> -->
      <el-form :inline="true" class="form">
        <el-row class="row">
          <el-col :span="23" :offset="1">
            <el-form-item
              label="姓名:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              <div style="display: inline-block; width: 253px">
                {{ userInfo.basic_info.nick_name }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="23" :offset="1">
            <el-form-item
              label="手机号:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              {{ userInfo.basic_info.user_mobile }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="23" :offset="1">
            <el-form-item
              label="卡上余额:"
              :label-width="formLabelWidth"
              class="formItem"
            >
              {{ this.userInfo.card_info.user_yue }}元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="23" :offset="1">
            <el-form-item
              label="退款金额:"
              :label-width="formLabelWidth"
              class="formItem"
              required
            >
              <el-input
                v-model="money"
                @input="inputPrice"
                size="small"
                style="width: 150px; padding-top: 4px"
              >
                <template slot="append">元</template>
              </el-input>
              最高退款金额：{{ this.userInfo.card_info.user_yue }}元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="23" :offset="1">
            <el-form-item
              label="退款备注:"
              :label-width="formLabelWidth"
              class="formItem"
              required
            >
              <el-input
                type="textarea"
                v-model="remark"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="msgBox" >
        <div style="margin-left: 50px; vertical-align: middle">
          <div class="msgBoxL">收款人姓名:</div>
          <el-input
            v-model="returnAccountParam.name"
            placeholder="请输入收款人姓名"
          ></el-input>

          <div class="msgBoxL">开户行:</div>
          <el-input
            v-model="returnAccountParam.bank_name"
            placeholder="请输入开户行信息"
          ></el-input>

          <div class="msgBoxL">银行卡号:</div>
          <el-input
            v-model="returnAccountParam.card_no"
            placeholder="请输入卡号"
          ></el-input>
        </div>
      </div>
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="handleClose">取消</div>
        <div class="btnItem submit" @click="submitCode">确定</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: true,
      formLabelWidth: "100px",
      money: "",
      remark: "",
	  // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    inputPrice() {
      this.money = this.$public.replaceGoodsDosage(this.money);
    },
    submitCode() {
      if (
        !this.$public.isNull(this.money) &&
        this.money <= this.userInfo.card_info.user_yue
      ) {
        console.log("判断成功");
      } else {
        this.$message({
          message: "退款金额输入有误！！",
          type: "error",
        });
        return;
      }
      if (this.remark.length < 16) {
        this.$message({
          message: "退款备注必须大于15个字符！！",
          type: "error",
        });
        return;
      }
      let params = {
        memberId: this.userInfo._id,
        returnMoney: Number(this.money),
        remark: this.remark,
		returnAccountParam:this.returnAccountParam
      };
      let loading = this.$loading();
      this.$http
        .post("/api/ReturnOrder/Return/MemberProperty", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$emit("submit", { type: "success", order: res.data });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">

.msgBox {
  display: flex;
  // padding: 20px;
  margin-bottom: 10px;
  & > span {
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
  .msgBoxL {
    height: 56px;
    line-height: 56px;
  }
}
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .avatar {
      width: 200px;
      display: block;
      margin: 80px auto 80px;
    }
    .form {
      ::v-deep .el-form-item {
        margin: 5px 0;
      }
      .row {
        float: none;
        border-bottom: 1px solid #f2f2f2;
        padding: 3px 0;
        .formItem {
          margin: 0;
        }
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
</style>
